<div class="fixed z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
    <!-- Background Overlay -->
    <div class="fixed inset-0 bg-[#D4D7DE] dark:bg-[#3333331f] bg-opacity-75 transition-opacity backdrop-blur-sm"></div>
    <div class="fixed inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
            <div class=" fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                <div class="w-screen max-w-3xl px-2 py-2 bg-white dark:bg-zinc-950 h-screen overflow-scroll">
                    <!-- Modal Content -->
                    <div>
                        <form class="mt-4 px-4">
                            <div class="flex justify-between">
                                <div>
                                    <h2 class="heading">
                                        Reason
                                    </h2>
                                    <p class="text-sm-light">
                                    </p>
                                </div>

                                <div>
                                    <button type="button" (click)="onCloseModal()"
                                        class="rounded-lg p-1 text-left text-base/6 font-medium text-zinc-950 dark:text-white sm:text-sm/5 hover:bg-zinc-950/5 dark:hover:bg-white/5">
                                        <span class="sr-only">Close panel</span>
                                        <!-- Heroicon name: outline/x-mark -->
                                        <svg class="size-5" xmlns="http://www.w3.org/2000/svg" fill="none"
                                            viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                            aria-hidden="true">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </div>

                            </div>

                            <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
                            <section class="flex-1 flex flex-col overflow-y-auto">
                                <ul role="list" class="">
                                    <form *ngIf="cancelReasons.length" action="" class="space-y-6">
                                      <fieldset>
                                        <legend class="sr-only">Notification method</legend>
                                        <div class="flex flex-wrap gap-2 items-start ">
                                          <div *ngFor="let reason of cancelReasons">
                                            <div class="flex items-center border border-dashed rounded dark:bg-white/5 bg-gray-50 py-1 px-2 ">
                                              <input [checked]="cancelReason === reason.title" (click)="setReason(reason.title)" [id]="reason.id"
                                                name="cancel-reason" type="radio" [value]="reason.title" />
                                              <label [for]="reason.id" class="ml-3 block text-sm font-medium text-main-secondary">{{ reason.title | titlecase }}</label>

                                            </div>
                                          </div>
                      
                                        </div>
                                      </fieldset>
                                      <div>
                                        <label for="other-reason" class="block text-sm font-medium text-main-secondary">Other Reason</label>
                                        <div class="mt-1">
                                          <textarea [(ngModel)]="cancelReason" rows="4" name="other-reason"
                                            class="resize-none form-control ng-pristine ng-untouched ng-valid ng-empty"
                                            id="example-textarea"></textarea>
                                        </div>
                                        <p *ngIf="!cancelReason || cancelReason === ''" class="mt-4 text-xs text-red-600">
                                          Kindly select the reason for cancellation.
                                        </p>
                                      </div>
                                      <div class="flex justify-end gap-2">
                                        <button [disabled]="!cancelReason || cancelReason === ''" type="button" class="btn btn-danger"
                                          (click)="cancelTrip()" data-dismiss="modal">Submmit</button>
                                        <!-- <button type="button" class="btn btn-primary" (click)="closeCancelModal()">No</button> -->
                                      </div>
                                    </form>
                                  </ul>
                            </section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>